import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";
import routes from "routes";
import footerRoutes from "footer.routes";
import SeoHead from "studio-edifique/components/SeoHead";
import ResponsiveImage from "studio-edifique/components/ResponsiveImage";
import {
  company,
  createOrganizationSchema,
  createBreadcrumbSchema,
} from "studio-edifique/siteContent";

function ContentLayout({
  title,
  description,
  intro,
  eyebrow,
  image,
  imageAlt,
  parent,
  schema = [],
  children,
}) {
  const { pathname } = useLocation();
  return (
    <>
      <SeoHead
        title={title}
        description={description}
        path={pathname}
        keywords={[title, "Studio Edifique", "Itatiba"]}
        image={image}
        imageSizes="(max-width: 900px) 100vw, 50vw"
        schema={[
          createOrganizationSchema(),
          createBreadcrumbSchema([
            { name: "Início", path: "/" },
            ...(parent ? [parent] : []),
            { name: title, path: pathname },
          ]),
          ...schema,
        ]}
      />
      <DefaultNavbar
        brand={company.brandName}
        routes={routes}
        relative
        action={{
          type: "external",
          route: company.whatsappUrl,
          label: "WhatsApp",
          color: "info",
        }}
      />
      <MKBox component="main">
        <MKBox component="section" py={{ xs: 6, md: 9 }} bgColor="grey-100">
          <Container>
            <MKBox
              component="nav"
              aria-label="Navegação estrutural"
              mb={4}
              display="flex"
              flexWrap="wrap"
              gap={1}
            >
              <MKTypography component={Link} to="/" variant="button" color="text">
                Início
              </MKTypography>
              {parent && (
                <MKTypography component={Link} to={parent.path} variant="button" color="text">
                  {" "}
                  / {parent.name}
                </MKTypography>
              )}
            </MKBox>
            <Grid container spacing={5} alignItems="center">
              <Grid item xs={12} md={image ? 6 : 10}>
                <MKTypography
                  variant="button"
                  color="info"
                  fontWeight="bold"
                  textTransform="uppercase"
                >
                  {eyebrow}
                </MKTypography>
                <MKTypography variant="h2" component="h1" mt={2} mb={3}>
                  {title}
                </MKTypography>
                <MKTypography variant="body1" color="text" mb={3}>
                  {intro}
                </MKTypography>
                <MKButton
                  component="a"
                  href={company.whatsappUrl}
                  target="_blank"
                  rel="noreferrer"
                  color="info"
                  variant="gradient"
                >
                  Solicitar atendimento
                </MKButton>
              </Grid>
              {image && (
                <Grid item xs={12} md={6}>
                  <ResponsiveImage
                    src={image}
                    alt={imageAlt || title}
                    eager
                    sizes="(max-width: 900px) 100vw, 50vw"
                    style={{ aspectRatio: "4 / 3", objectFit: "cover" }}
                  />
                </Grid>
              )}
            </Grid>
          </Container>
        </MKBox>
        <Container sx={{ py: { xs: 5, md: 8 } }}>{children}</Container>
      </MKBox>
      <DefaultFooter content={footerRoutes} />
    </>
  );
}

ContentLayout.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  intro: PropTypes.string.isRequired,
  eyebrow: PropTypes.string.isRequired,
  image: PropTypes.string,
  imageAlt: PropTypes.string,
  parent: PropTypes.shape({ name: PropTypes.string, path: PropTypes.string }),
  schema: PropTypes.arrayOf(PropTypes.object),
  children: PropTypes.node.isRequired,
};

export default ContentLayout;
